import React, { useState, useEffect } from 'react'
import { List } from '@chakra-ui/core'
import { ICartItemDetail } from '@engyalo/storefront-types'
import { UnorderedList } from '@engyalo/storefront-components'

export const CustomCartItem = ({ cart, product }: ICartItemDetail) => {
  const [mappedItems, setMappedItems] = useState<string[]>([])

  const cartItem = cart[product?.cartId ?? '']

  useEffect(() => {
    if (cartItem) {
      const customizationsSelected = cartItem.customizations?.map((option) => {
        if (option) {
          return `${option?.name}: ${option?.customizations?.map((item) => item?.name)?.join(', ')}`
        }
        return ''
      })
      if (customizationsSelected) {
        setMappedItems(customizationsSelected)
      }
    }
  }, [cartItem])

  if (!cartItem) {
    return null
  }

  return (
    <List mb="4" styleType="square">
      <UnorderedList items={mappedItems} />
    </List>
  )
}
